"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCategoriesWithRestrictionsResponseToJSON = exports.AdCategoriesWithRestrictionsResponseFromJSONTyped = exports.AdCategoriesWithRestrictionsResponseFromJSON = exports.instanceOfAdCategoriesWithRestrictionsResponse = void 0;
var runtime_1 = require("../runtime");
var AdCategoriesWithRestrictions_1 = require("./AdCategoriesWithRestrictions");
/**
 * Check if a given object implements the AdCategoriesWithRestrictionsResponse interface.
 */
function instanceOfAdCategoriesWithRestrictionsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdCategoriesWithRestrictionsResponse = instanceOfAdCategoriesWithRestrictionsResponse;
function AdCategoriesWithRestrictionsResponseFromJSON(json) {
    return AdCategoriesWithRestrictionsResponseFromJSONTyped(json, false);
}
exports.AdCategoriesWithRestrictionsResponseFromJSON = AdCategoriesWithRestrictionsResponseFromJSON;
function AdCategoriesWithRestrictionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : (json['categories'].map(AdCategoriesWithRestrictions_1.AdCategoriesWithRestrictionsFromJSON)),
    };
}
exports.AdCategoriesWithRestrictionsResponseFromJSONTyped = AdCategoriesWithRestrictionsResponseFromJSONTyped;
function AdCategoriesWithRestrictionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'categories': value.categories === undefined ? undefined : (value.categories.map(AdCategoriesWithRestrictions_1.AdCategoriesWithRestrictionsToJSON)),
    };
}
exports.AdCategoriesWithRestrictionsResponseToJSON = AdCategoriesWithRestrictionsResponseToJSON;
